import React from 'react'
import { IBulkAction } from '../../../../Component/Common/Components/DataTable/BulkAction';
import { DataTable } from '../../../../Component/Common/Components/DataTable/DataTable';
import { IFilter } from '../../../../Component/Common/Components/DataTable/Filters';
import { ColumnSortOption } from '../../../../Component/Model/Dto/ColumnSortOption';
import { EntriesPerPage } from '../../../../Component/Model/Table/Table';
import { EmployeeSalariesTable } from './EmployeeSalariesColumns';

interface IEmployeeSalariesDataTable {
    employeeSalariesData: EmployeeSalariesTable;
    entriesPerPage: EntriesPerPage;
    pageNumber: number;
    filteredItemsCount: number;
    totalItemsCount: number;
    entriesPerPageChanged: (entriesPerPage: number) => void;
    pageNumberChanged: (pageNumber: number) => void;
    searchValueChanged: (searchValue: string) => void;
    columnSortingChanged: (sortOption: ColumnSortOption) => void;
    isLoading: boolean;
    hasFilters: boolean;
    employeeSalariesFilters: IFilter[];
    filtersChanged: (filterProps: any) => void;
}

export const EmployeeSalariesDataTable = (props: IEmployeeSalariesDataTable) => {
    return (
        <>
            {props.hasFilters ?
                <DataTable
                    key={props.totalItemsCount}
                    table={props.employeeSalariesData}
                    entriesPerPage={props.entriesPerPage}
                    pageNumber={props.pageNumber}
                    filteredItemsCount={props.filteredItemsCount}
                    totalItemsCount={props.totalItemsCount}
                    entriesPerPageChanged={props.entriesPerPageChanged}
                    pageNumberChanged={props.pageNumberChanged}
                    isLoading={props.isLoading}
                    canSearch
                    searchValueChanged={props.searchValueChanged}
                    filters={props.employeeSalariesFilters}
                    filtersChanged={props.filtersChanged}
                    manualSorting
                    columnSortingChanged={props.columnSortingChanged}
                ></DataTable>
                :
                <DataTable
                    key={props.totalItemsCount}
                    table={props.employeeSalariesData}
                    entriesPerPage={props.entriesPerPage}
                    pageNumber={props.pageNumber}
                    filteredItemsCount={props.filteredItemsCount}
                    totalItemsCount={props.totalItemsCount}
                    entriesPerPageChanged={props.entriesPerPageChanged}
                    pageNumberChanged={props.pageNumberChanged}
                    isLoading={props.isLoading}
                    canSearch
                    searchValueChanged={props.searchValueChanged}
                    manualSorting
                    columnSortingChanged={props.columnSortingChanged}
                ></DataTable>
            }
        </>
    )
}

